import { render, staticRenderFns } from "./SettlementList.vue?vue&type=template&id=070bb108&scoped=true"
import script from "./SettlementList.vue?vue&type=script&lang=js"
export * from "./SettlementList.vue?vue&type=script&lang=js"
import style0 from "./SettlementList.vue?vue&type=style&index=0&id=070bb108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bb108",
  null
  
)

export default component.exports